import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { FaMapMarkerAlt, FaEnvelope, FaPhone } from "react-icons/fa";

export default function Contact() {
  const { t } = useTranslation();

  return (
    <section className="Contact fade">
      <div className="contact-map">
        {/* Tu peux remplacer l’iframe par une vraie map plus tard */}
        <iframe
          title="Carte"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2890.658222884257!2d7.2619!3d43.7102!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12cddaa9f1184d91%3A0x908d2b5ff9912cd5!2sNice!5e0!3m2!1sfr!2sfr!4v0000000000"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </div>

      <div className="contact-content">
        <h2>{t("contact.title")}</h2>
        <p>{t("contact.text1")}</p>
        <p>{t("contact.text2")}</p>

        <div className="contact-icons">
          <div>
            <FaMapMarkerAlt className="icon red" />
            <FaEnvelope className="icon green" />
            <FaPhone className="icon yellow" />
          </div>
          <Link className="button" to="/contact">
            {t("contact.button")}
          </Link>
        </div>
      </div>
    </section>
  );
}
